import { frontendURL } from '../../../../helper/URLHelper';
import BotFrame from './components/BotFrame.vue';
import SettingsContent from '../Wrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/bot'),
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: SettingsContent,
      props: {
        headerTitle: 'BOT_SETTINGS.TITLE',
        icon: 'bot',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'bot_frame',
          component: BotFrame,
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
          },
          props: { url: '' },
        },
      ],
    },
  ],
};
